import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class CssRender extends BasicEntity {
code: string;
css: string;
description: TranslatedEmb;
label: TranslatedEmb;
vision: string;
}

